import {Component} from 'react';

class Localize extends Component {

    constructor(props) {
        super(props);

        this.applySettings = this.applySettings.bind(this);
    }

    applySettings(content) {
        var settings = this.props.Settings;
        if (settings.language === "fr") {
            return content.fr;
        } else if (settings.country === "US" && content.us_alt !== "") {
            return content.us_alt;
        } else {
            return content.en;
        }
    }
}

export default Localize


// WEBPACK FOOTER //
// ./src/components/Localize.js